<mat-card class="mat-card--widget">
  <mat-card-content>
    <div class="container">
      <div class="row">
        <div class="col s12 m9">
          <mat-form-field>
            <input
              matInput
              [matDatepicker]="picker"
              placeholder="Search My Orders"
              (keyup)="search$.next($event)"
              (dateInput)="searchDate($event)"
            />
          </mat-form-field>
        </div>
        <div class="col s12 m3 align-search" id="button_date_container">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <!--           <button (click)="exportAsXLSX()" class="btn btn-primary downloadXlsxButton">
            Download Orders
          </button> -->
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
